import { Link } from "react-router-dom"
import { AlertMessage } from "source/shared/components"
import { useChurchCenterIframe } from "source/shared/hooks/useChurchCenterIframe"
import { UnverifiedPaymentMethod } from "../types"

interface UnverifiedPaymentMethodAlertProps {
  paymentMethods: UnverifiedPaymentMethod[]
}

export function UnverifiedPaymentMethodAlert({
  paymentMethods,
}: UnverifiedPaymentMethodAlertProps) {
  const { inIframe } = useChurchCenterIframe()

  if (paymentMethods.length === 0) {
    return null
  }

  const { title, message, linkText } =
    paymentMethods.length === 1
      ? {
          title: "You have an unverified bank account",
          message: (
            <>
              To donate with the account ending in{" "}
              <strong>{paymentMethods[0].last4}</strong>, follow the
              verification instructions in your email.
            </>
          ),
          linkText: "Verify account",
        }
      : {
          title: "You have unverified bank accounts",
          message:
            "To donate with one of these accounts, follow the verification instructions in your email.",
          linkText: "Manage payment methods",
        }

  const isAppGuestMode = sessionStorage.getItem("app_guest_mode") === "true"
  const showVerifyLink = !isAppGuestMode && !inIframe

  return (
    <AlertMessage
      type="warning"
      icon="general#exclamation-triangle"
      className="mt-2"
      data-testid="unverified-payment-method-alert"
    >
      <div className="d-f fd-c g-4p">
        <strong>{title}</strong>
        <div>{message}</div>
        {showVerifyLink && (
          <Link to="/me/profile/payment-methods">{linkText}</Link>
        )}
      </div>
    </AlertMessage>
  )
}
